<template>
  <div>
    <div class="c-base-transaction-details__price">
      <div class="c-base-transaction-details__icon has-text-error">
        <base-icon width="24" height="24" :name="icon" />
      </div>
      <div class="c-base-transaction-details__amount has-text-error">
        - {{ transaction.amount | currency }}
      </div>

      <p class="c-base-transaction-details__category">
        <strong>Estorno de presente</strong>
        <br />
        <small>Realizada em {{ transaction.created_at | date }}</small>
      </p>
    </div>
    <div class="c-base-transaction-details__body">
      <div
        class="columns is-mobile is-vcentered is-gapless is-multiline margin-bottom"
      >
        <div class="column is-half">
          <p class="is-size-6">
            <strong>Valor estornado</strong>
          </p>
        </div>
        <div class="column is-half has-text-right">
          <strong class="has-text-error is-size-6">
            {{ -transaction.amount | currency }}
          </strong>
        </div>
      </div>

      <a
        v-if="referenceTransaction"
        @click="emitReferenceTransaction"
        class="columns is-vcentered is-mobile is-gapless is-multiline margin-bottom"
        href="#"
      >
        <div class="column">
          <p class="has-text-black margin-bottom">
            Referente ao presente<br />
            <strong
              v-if="referenceTransaction.category.toUpperCase() === 'GIFT'"
            >
              {{ referenceTransaction.details.gift_name }}
            </strong>
          </p>
          <p class="has-text-black">
            De {{ referenceTransaction.details.guest_name }}
            <br />
            Em {{ referenceTransaction.created_at | date }}
          </p>
        </div>
        <div class="column is-1 has-text-right">
          <base-icon
            width="24px"
            height="24px"
            name="painel/arrow-right-icon"
            class="has-text-grey-dark"
          />
        </div>
      </a>

      <div class="c-base-transaction-details__footer">
        <p class="is-size-6">
          Código da transação<br />
          <strong>{{ transaction.transaction_id }}</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTransactionDetailsMixin from '@/mixins/BaseTransactionDetailsMixin'

import WalletApi from '@/lib/api/Wallet'

export default {
  mixins: [BaseTransactionDetailsMixin],

  props: {
    transaction: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    transactions() {
      return this.$store.state.wallet.transactions
    },

    transactionsLoadeds: {
      get() {
        return this.$store.state.wallet.transactionsLoadeds
      },
      set(payload) {
        this.$store.dispatch('setTransactionsLoadeds', payload)
      },
    },
  },

  data() {
    return {
      referenceTransaction: null,
    }
  },

  mounted() {
    this.getReferenceTransaction()
  },

  methods: {
    getReferenceTransaction() {
      const reference = this.transactionsLoadeds.find(
        (transaction) =>
          transaction.transaction_id === this.transaction.reference_id
      )
      if (reference) {
        this.referenceTransaction = reference
        return
      }
      const walletApi = new WalletApi(this.logonToken)
      walletApi
        .getTransaction(this.transaction.reference_id)
        .then((response) => {
          this.referenceTransaction = response.data.data
          this.transactionsLoadeds = this.transactionsLoadeds.concat(
            this.referenceTransaction
          )
          this.referenceTransaction
        })
        .catch(null)
    },

    emitReferenceTransaction() {
      this.$emit('open-reference')
    },
  },
}
</script>

<style lang="scss" scoped></style>
